export const hireGoLangContent = {
  // Helmet Content
  helmet: {
    title: "Hire Golang Developers | Golang Development Services",
    description: "Hire skilled Golang developers for fast, reliable applications. Expert Go development services for modern, scalable solutions.",
  },

  // HirePageBanner Content
  mainBanner: {
    backgroundImage: `url(/images/hire-page-images/Golang.png)`,
    mainHeading: "Hire Remote Golang Developers",
    content: "Looking to hire Golang developers? We provide pre vetted experts to help you build secure, scalable, & high performance applications perfect for startups & enterprises.",
    btnText: "Consult our Go lang developers",
    bannerList: [
      { list: "Freelance contractors" },
      { list: "Full-time roles" },
      { list: "Global teams" },
    ],
  },

  // HirePageExperties Content
  golangExpertise: {
    btnText: "Schedule a Call Today",
    heading: "Our Golang Developer Expertise",
    description: "At Bitsclan, we deliver high-performance Golang solutions tailored to your business needs. Whether you need API development, migration services, or full-scale applications, our experienced developers ensure efficiency, scalability, & security.",
    servicesData: [
      {
        title: "Golang Consulting",
        description: "Get expert advice & strategic guidance to make the most of your Golang projects. Our developers will help you plan & implement your ideas to ensure success.",
        icon: "/images/hire-page-icons/go-lang-1.svg",
      },
      {
        title: "Golang web Development",
        description: "Our developers are skilled at building scalable & feature-rich web applications using Golang. Whether you're building a new platform or enhancing an existing one, we provide robust & efficient solutions.",
        icon: "/images/hire-page-icons/go-lang-2.svg",
      },
      {
        title: "Golang API Development",
        description: "Our developers excel at Golang API development, creating seamless communication between applications. This allows you to connect your systems effortlessly & ensure smooth data transfer.",
        icon: "/images/hire-page-icons/go-lang-3.svg",
      },
      {
        title: "CMS & Portal Development",
        description: "Trust our experts to build content management systems & web portals that are powerful, secure, & easy to use, all powered by Golang. We create user-friendly, high-performance platforms to meet your business needs.",
        icon: "/images/hire-page-icons/go-lang-4.svg",
      },
      {
        title: "Migration to Golang",
        description: "Our Golang developers make the transition to Golang application development easy & smooth. We can help you migrate your existing systems to Golang without disrupting your operations.",
        icon: "/images/hire-page-icons/go-lang-5.svg",
      },
      {
        title: "Integration with Existing Solutions",
        description: "Our team has extensive experience in integrating Golang applications with your existing platforms & services. Whether it's for databases, third-party tools, or other systems, we ensure seamless integration.",
        icon: "/images/hire-page-icons/go-lang-6.svg",
      },
      {
        title: "Golang eCommerce Solutions",
        description: "Developing eCommerce solutions with Golang ensures a fast, secure, & highly interactive user experience. Our experts build reliable & scalable platforms that deliver optimal performance for online stores.",
        icon: "/images/hire-page-icons/go-lang-7.svg",
      },
      {
        title: "Golang Support & Maintenance",
        description: "We provide ongoing support & maintenance services for your Golang applications, ensuring they stay efficient, secure, & up-to-date. Our team is dedicated to keeping your systems running smoothly.",
        icon: "/images/hire-page-icons/go-lang-8.svg",
      },
    ],
  },

  // DevelopmentPerformance Content (Why Choose Us)
  whyChooseUs: {
    btnText: "Hire a developer today",
    heading: "Why Choose Us to Hire ",
    greenHeading: "Golang developers",
    subHeading: "At Bitsclan, we combine Golang with modern frontend & backend technologies to create robust, scalable applications. Whether you're developing a web platform or a microservices-based architecture, our experts ensure seamless performance & fast development cycles.",
    solutionsData: [
      {
        icon: "/images/hire-page-icons/chose-ror-section1.svg",
        title: "Access vetted talent",
        description: "When you hire Golang developers from us, you're getting experts who are thoroughly vetted for both their technical skills & English proficiency.",
      },
      {
        icon: "/images/hire-page-icons/chose-ror-section2.svg",
        title: "View matches in seconds",
        description: "No need to sift through piles of resumes. With HireAI, you can instantly view & select the best Golang developers for hire who match your project requirements.",
      },
      {
        icon: "/images/hire-page-icons/chose-ror-section3.svg",
        title: "Save with global hires",
        description: "Access a global pool of over 450,000 developers from 190 countries. By hiring from a global talent pool, you can save up to 58% compared to traditional hiring methods, while still getting top-tier expertise in Golang application development.",
        noBorder: true,
      },
      {
        icon: "/images/hire-page-icons/chose-ror-section4.svg",
        title: "Get real human support",
        description: "At Bitsclan, you're not just hiring developers; you're getting the support of our team of expert recruiters who are dedicated to helping you find the right talent. Feel confident knowing you'll have real, hands-on assistance throughout the process.",
      },
    ],
  },

  // HireCombinationSection Content
  techCombinations: {
    heading: "Top GoLang Technology Combinations for High-Performance Development",
    description: "Maximize efficiency & scalability with the best GoLang technology combinations. Hire expert GoLang developers to build robust, high-performing, & secure applications tailored to your business needs.",
    combinations: [
      {
        title: "Go + Gin + PostgreSQL",
        description:
          "Gin, a lightweight Go web framework, combined with PostgreSQL, provides a high-performance & scalable backend solution.",
        icons: [
          { icon: "golang.svg", altText: "Go programming language" },
          { icon: "gin-cae.svg", altText: "Gin web framework" },
          { icon: "postgres.svg", altText: "PostgreSQL database" },
        ],
      },
      {
        title: "Go + Echo + MySQL",
        description:
          "Echo, a fast & minimalistic Go web framework, paired with MySQL, enables efficient development of scalable applications.",
        icons: [
          { icon: "golang.svg", altText: "Go programming language" },
          { icon: "echo-icon.svg", altText: "Echo web framework" },
          { icon: "mysql-whale-icon.svg", altText: "MySQL database" },
        ],
      },
      {
        title: "Go + Fiber + MongoDB",
        description:
          "Fiber, an Express-inspired Go framework, combined with MongoDB, ensures high-speed API development with flexible NoSQL storage.",
        icons: [
          { icon: "golang.svg", altText: "Go programming language" },
          { icon: "fiber.svg", altText: "Fiber web framework" },
          { icon: "mongodb.svg", altText: "MongoDB NoSQL database" },
        ],
      },
      {
        title: "Go + React + PostgreSQL",
        description:
          "React for dynamic front-end development, Go for efficient backend logic, & PostgreSQL for a reliable relational database.",
        icons: [
          { icon: "golang.svg", altText: "Go programming language" },
          { icon: "react.svg", altText: "React.js frontend library" },
          { icon: "postgres.svg", altText: "PostgreSQL database" },
        ],
      },
      {
        title: "Go + gRPC + Kubernetes",
        description:
          "Go with gRPC enables efficient microservices communication, while Kubernetes provides scalable container orchestration.",
        icons: [
          { icon: "golang.svg", altText: "Go programming language" },
          { icon: "grpc.svg", altText: "gRPC communication framework" },
          { icon: "kubernetes.svg", altText: "Kubernetes container orchestration" },
        ],
      },
      {
        title: "Go + GraphQL + AWS",
        description:
          "Go for backend logic, GraphQL for flexible API queries, & AWS for scalable cloud computing & storage solutions.",
        icons: [
          { icon: "golang.svg", altText: "Go programming language" },
          { icon: "graphql.svg", altText: "GraphQL query language" },
          { icon: "aws.svg", altText: "AWS cloud services" },
        ],
      },
    ],
  },

  // HirePageSteps Content
  hireSteps: {
    btnText: "Let’s Find Your Perfect Developer",
    heading: "Hire Golang Developers in 4 Easy Steps",
    subHeading: "At Bitsclan, we make it easy to hire Golang developers with a straightforward 4-step process. We focus on making sure you get the right talent for your project, quickly & effectively.",
    steps: [
      {
        title: "Choose your Engagement Model",
        description: "Select the engagement model that suits your needs best whether it’s Full-Time, Part-Time, or Hourly. This flexibility ensures you get the support you need based on your project requirements.",
        icon: "/images/hire-page-setps-icons/icon-1.svg"
      },
      {
        title: "Screen & Select Golang Developers",
        description: "Browse through profiles of Go developers for hire & pick the candidates who best match your project needs. Choose based on skills, experience, & expertise.",
        icon: "/images/hire-page-setps-icons/icon-2.svg"
      },
      {
        title: "Conduct One-on-One Interview",
        description: "Interview the shortlisted candidates to assess their skills. You can test them with theoretical & practical questions to ensure they are the right fit.",
        icon: "/images/hire-page-setps-icons/icon-3.svg"
      },
      {
        title: "Onboard Golang Developers",
        description: "Once you've made your final choice, the selected Golang developer will join your team within 24-48 hours. This ensures a smooth transition & quick project progress.",
        icon: "/images/hire-page-setps-icons/icon-4.svg"
      }
    ],
  },

  // CoverTheStack Content
  coverTheStack: {
    whereStart: "Framework",
    mainHeading: "Boost Your Web Development with High-Performance Golang Solutions",
    subHeading: "At Bitsclan, we empower your web development journey with a powerful Golang tech stack that ensures efficiency, scalability, & speed. Our expert Golang developers leverage modern technologies to build robust, high-performance web applications tailored to your business needs.",
    tabs: [
      "Framework",
      "Package",
      "Database",
      "Cloud Services",
      "Tools",
      "Communication",
    ],
    tabItems: [
      { tab: "Framework", icon: "/images/tech-stack-icons/gin-cae.svg", name: "Gin" },
      { tab: "Framework", icon: "/images/tech-stack-icons/echo-icon.svg", name: "Echo" },
      { tab: "Framework", icon: "/images/tech-stack-icons/beego-icon.svg", name: "Beego" },
      { tab: "Framework", icon: "/images/tech-stack-icons/revel-icon.png", name: "Revel" },
      { tab: "Framework", icon: "/images/tech-stack-icons/buffalo-icon.svg", name: "Buffalo" },
      { tab: "Framework", icon: "/images/tech-stack-icons/goa-icon.svg", name: "Goa" },
      { tab: "Framework", icon: "/images/tech-stack-icons/fiber.svg", name: "Fiber" },
      { tab: "Framework", icon: "/images/tech-stack-icons/chi-icon.svg", name: "Chi" },
      { tab: "Framework", icon: "/images/tech-stack-icons/image-icon.svg", name: "Google Protobuf" },

      { tab: "Package", icon: "/images/tech-stack-icons/chi-icon.svg", name: "Chi" },
      { tab: "Package", icon: "/images/tech-stack-icons/stringer-icon.svg", name: "Stringer" },
      { tab: "Package", icon: "/images/tech-stack-icons/gorilla-icon.svg", name: "Gorilla Mux" },
      { tab: "Package", icon: "/images/tech-stack-icons/gorm-icon.svg", name: "GORM" },

      { tab: "Database", icon: "/images/db5.png", name: "MySQL" },
      { tab: "Database", icon: "/images/db3.png", name: "MongoDB" },
      { tab: "Database", icon: "/images/tech-stack-icons/redis.svg", name: "Redis" },
      { tab: "Database", icon: "/images/tech-stack-icons/postgres.svg", name: "Postgres" },
      { tab: "Database", icon: "/images/tech-stack-icons/elasticsearch.svg", name: "ElasticSearch" },

      { tab: "Cloud Services", icon: "/images/devops3.png", name: "Docker" },
      { tab: "Cloud Services", icon: "/images/cloud3.png", name: "AWS" },
      { tab: "Cloud Services", icon: "/images/cloud2.png", name: "Azure" },
      { tab: "Cloud Services", icon: "/images/cloud1.png", name: "Google Cloud" },
      { tab: "Cloud Services", icon: "/images/tech-stack-icons/digital-ocean.svg", name: "Digital Ocean" },

      { tab: "Tools", icon: "/images/tech-stack-icons/postman.svg", name: "Postman" },
      { tab: "Tools", icon: "/images/tech-stack-icons/postgres.svg", name: "PG Admin" },
      { tab: "Tools", icon: "/images/tech-stack-icons/git-hub.svg", name: "Git" },
      { tab: "Tools", icon: "/images/tech-stack-icons/gitlab.svg", name: "gitlab" },

      { tab: "Communication", icon: "/images/tech-stack-icons/rest-apis.svg", name: "Rest APIs" },
      { tab: "Communication", icon: "/images/tech-stack-icons/grpc.svg", name: "gRPC" },
      { tab: "Communication", icon: "/images/tech-stack-icons/sockets.svg", name: "Web Sockets" },
      { tab: "Communication", icon: "/images/tech-stack-icons/graph.svg", name: "GraphQl" },
      { tab: "Communication", icon: "/images/tech-stack-icons/apache.svg", name: "Apache" },
      { tab: "Communication", icon: "/images/tech-stack-icons/kafka.svg", name: "Kafka" },
      { tab: "Communication", icon: "/images/tech-stack-icons/rabbit.svg", name: "RabbitMQ" },
    ],
  },

  // HireExpertFacts Content
  expertFacts: {
    btnText: "book an appointment",
    heading: "Quick Facts About ",
    greenHeading: "Our Golang Team",
    facts: [
      { text: "We have a team of over 40 experienced Golang developers." },
      { text: "The average experience of our developers is 25.98 years." },
      { text: "Our developers have extensive experience in Golang application development." },
      { text: "We rely on a mature DevOps culture for smooth workflows." },
      { text: "We specialize in scalable solutions with Golang & cloud-native development." },
      { text: "Our team has expertise in big data, IoT, machine learning, & blockchain technology." },
    ],
    backgroundImage: `url(/images/hire-page-images/hire-golang.avif)`
  },

  // HirePageAppIdea Content
  appIdeaSection: {
    heading: "Not sure about your app idea? Get your prototype up in 6-8 weeks!",
    content: "Have an idea but unsure how to proceed? Our Golang experts can help you build a functional prototype in just 6-8 weeks! Validate your vision, test user engagement, & establish a strong foundation for success with our expert development services.",
  },

  // HirePageEngagementModels Component Props
  hirePageEngagementModels: {
    btnText: "Get Started Now",
    headingContent: [
      { text: "Our Flexible" },
      { text: "Engagement Models" },
    ],
    discription: "Choose the engagement model that fits your project needs! Whether you need full-time, part-time, or hourly developers, we offer flexible options to ensure seamless collaboration & maximum efficiency throughout your project.",
    hiringDetails: [
      {
        text: "Hourly Hiring",
        hours: "48",
        timeUnit: "hours",
        icon: "time.svg",
        bgColor: "#FDFDFF",
        durationLabel: "Duration",
        duration: "8 Hrs/Day",
        minimumDaysLabel: "Minimum Days",
        minimumDays: "30 Days",
        billingLabel: "Billing",
        billing: "Monthly",
        startWorkPhrase: "Start work in "
      },
      {
        text: "Full Time Hiring",
        hours: "72",
        timeUnit: "hours",
        icon: "full-time.svg",
        bgColor: "#FFFEFA",
        durationLabel: "Duration",
        duration: "8 Hrs/Day",
        minimumDaysLabel: "Minimum Days",
        minimumDays: "30 Days",
        billingLabel: "Billing",
        billing: "Monthly",
        startWorkPhrase: "Get started within "
      },
      {
        text: "Part Time Hiring",
        hours: "48",
        timeUnit: "hours",
        icon: "part-time.svg",
        bgColor: "#FDFFFA",
        durationLabel: "Duration",
        duration: "8 Hrs/Day",
        minimumDaysLabel: "Minimum Days",
        minimumDays: "30 Days",
        billingLabel: "Billing",
        billing: "Monthly",
        startWorkPhrase: "Launch in "
      },
    ],
  },

  // SecondFaq Content
  faqSection: {
    mainHeading: "Frequently Asked Questions",
    subHeading: "Explore our Golang development services for tailored web solutions, API creation, & deployment management!",
    faqData: [
      {
        id: "collapseOne",
        question: "Why do companies choose Golang for backend development?",
        answer: "Golang’s speed, concurrency, and scalability make it perfect for distributed systems, cloud platforms, and APIs that require real-time processing and low latency.",
      },
      {
        id: "collapseTwo",
        question: "Can you provide both short-term and long-term engagement options?",
        answer: "Our Flexible Model allows hourly or project-based collaboration, while the Dedicated Team ensures consistent delivery for long-term goals.",
      },
      {
        id: "collapseThree",
        question: "How experienced are your Golang developers?",
        answer: "Each engineer has 5–10 years of experience in Go, Kubernetes, Docker, AWS, and cloud-native microservices architecture.",
      },
      {
        id: "fourth",
        question: "Do you build and deploy CI/CD pipelines for Go projects?",
        answer: "We use Jenkins, GitHub Actions, and Kubernetes for automated testing, deployment, and rollback with zero downtime.",
      },
      {
        id: "fifth",
        question: "Can you migrate legacy systems to Go?",
        answer: "We gradually refactor and migrate legacy systems, ensuring improved performance, maintainability, and minimal disruption.",
      },
      {
        id: "sixth",
        question: "What industries benefit most from Go?",
        answer: "FinTech, logistics, SaaS, IoT, and streaming platforms use Go for high-concurrency and secure processing.",
      },
      {
        id: "seventh",
        question: "Do you offer performance optimization and code audits?",
        answer: "Our team runs profiling, memory leak detection, and benchmark testing to optimize resource usage and system speed.",
      },
      {
        id: "eighth",
        question: "How do you ensure data security and compliance?",
        answer: "We follow ISO, SOC 2, and GDPR standards, ensuring encrypted communication, secure credentials, and access control.",
      },
    ],
  },

  // You can remove other individual exports if they are now nested.
  // For example, if 'bannerList' is only used within 'mainBanner', it doesn't need to be a separate export.
  // I've kept them as separate for now, but you can clean them up.
};

// You can still keep these if they are used elsewhere independently,
// otherwise, it's better to move them inside hireGoLangPageContent.
// For the purpose of this request, I've moved them all inside the main object.

export const hireGoLangEngagementModeContent = {
  shortHeading: "Our Engegement Models",
  heading: "Engagement Packages",
  subheading: "Choosing the right engagement model is crucial. We offer flexible options, from dedicated development teams to project-based partnerships, ensure transparency, seamless collaboration, & maximum efficiency aligned with your AI, web, or IT project goals.",
  models: [
    {
      icon: "/images/engagement-model-gifs/hourly-icon.svg",
      index: 1,
      iconWidth: 40,
      title: "Flexible Model",
      description: "Scale your development team effortlessly with pre-vetted Golang experts who integrate into your existing workflows. Ideal for fast-moving companies that need on-demand backend scalability without long-term commitments. Perfect for building APIs, microservices, and real-time systems while maintaining agility and cost control.",
    },
    {
      icon: "/images/engagement-model-gifs/price-icon.svg",
      index: 2,
      iconWidth: 35,
      title: "Dedicated Team",
      description: "For organizations seeking a long-term backend partner. A fully managed team of Golang engineers, DevOps experts, and QA specialists works exclusively on your product. Ideal for building and maintaining cloud-native infrastructures, high-performance data systems, and enterprise-grade applications with continuous delivery and monitoring.",
    }
  ],
  cta: {
    text: "Go Faster, Go Smarter. Elite Go Lang (Golang) Development Talent.",
    button: "Hire Your Go Lang Expert Today",
    link: "/contact-us"
  },

  faqSection: {
    mainHeading: "Frequently Asked Questions",
    faqData: [
      {
        id: "collapseOne",
        question: "Why do companies choose Golang for backend development?",
        answer:
          "Golang’s speed, concurrency, and scalability make it perfect for distributed systems, cloud platforms, and APIs that require real-time processing and low latency.",
      },
      {
        id: "collapseTwo",
        question: "Can you provide both short-term and long-term engagement options?",
        answer:
          "Yes. Our Flexible Model allows hourly or project-based collaboration, while the Dedicated Team ensures consistent delivery for long-term goals.",
      },
      {
        id: "collapseThree",
        question: "How experienced are your Golang developers?",
        answer:
          "Each engineer has 5–10 years of experience in Go, Kubernetes, Docker, AWS, and cloud-native microservices architecture.",
      },
      {
        id: "collapseFour",
        question: "Do you build and deploy CI/CD pipelines for Go projects?",
        answer:
          "Absolutely. We use Jenkins, GitHub Actions, and Kubernetes for automated testing, deployment, and rollback with zero downtime.",
      },
      {
        id: "collapseFive",
        question: "Can you migrate legacy systems to Go?",
        answer:
          "Yes. We gradually refactor and migrate legacy systems, ensuring improved performance, maintainability, and minimal disruption.",
      },
      {
        id: "collapseSix",
        question: "What industries benefit most from Go?",
        answer:
          "FinTech, logistics, SaaS, IoT, and streaming platforms use Go for high-concurrency and secure processing.",
      },
      {
        id: "collapseSeven",
        question: "Do you offer performance optimization and code audits?",
        answer:
          "Yes. Our team runs profiling, memory leak detection, and benchmark testing to optimize resource usage and system speed.",
      },
      {
        id: "collapseEight",
        question: "How do you ensure data security and compliance?",
        answer:
          "We follow ISO, SOC 2, and GDPR standards, ensuring encrypted communication, secure credentials, and access control.",
      },
    ],
  },
}